// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#mailvelope-composer[data-v-17d2a4b0] {\n\twidth: 100%;\n\theight: 450px;\n}\n", ""]);
// Exports
module.exports = exports;
